
import { CompanyDossierService } from "@/services";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			createBackup: false,
			startDate: null as null | Date,
			endDate: null as null | Date,
			startBookYear: 0,
			endBookYear: 0
		};
	},
	props: {
		dossierId: {
			type: Number,
			required: true
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async confirm(){
			if (!this.createBackup) {
				let confirm = await this.$wf.confirm("Dit is een destructieve taak. Weet je zeker dat je niet eerst een backup wilt maken", "Ja", "Nee", "Waarschuwing", "danger");
				if (!confirm) return;
			}
			await CompanyDossierService.recreateStockOuts(this.dossierId, this.startDate, this.endDate, this.startBookYear, this.endBookYear, this.createBackup);
			this.close();

		}
	}
});
